import { Label } from 'components/Form'
import { Checkbox } from 'components/Form/Checkbox'
import { ChangeEvent, FocusEventHandler } from 'react'
import { noop } from 'utils'

export interface CheckboxInputProps {
  name: string
  value: boolean
  label: string
  setFieldValue: (field: string, value: boolean) => void
  onBlur?: FocusEventHandler
  disabled?: boolean
  tabIndex?: number
}

export const CheckboxInput = ({
  value,
  name,
  label,
  setFieldValue,
  onBlur = noop,
  disabled,
  tabIndex,
}: CheckboxInputProps) => {
  const handleChange = (evt: ChangeEvent<HTMLInputElement>) => {
    const {
      target: { name, checked },
    } = evt
    setFieldValue(name, checked)
  }
  return (
    <Label variant="layout.labelWithCheckbox">
      <Checkbox
        name={name}
        checked={value}
        disabled={disabled}
        onChange={handleChange}
        onBlur={onBlur}
        tabIndex={tabIndex}
      />
      {label}
    </Label>
  )
}
